import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { toast } from 'react-toastify'

import { useProduct } from '../hooks/useProduct'
import { EditProduct } from '../components/Products/EditProduct'

export const EditProductPage = () => {
  const { productId } = useParams<{ productId: string }>()
  const { product, error: productError, refetchProduct } = useProduct(productId)
  const loading = productId && !productError && !product ? true : false

  useEffect(() => {
    if (productError?.response?.status === 404) {
      toast('Product ID does not exist.', { containerId: 'error' })
    }
  }, [productError])

  return <EditProduct product={product} loading={loading} refetchProduct={refetchProduct} />
}
